import Vue from "vue";
import Vuex from 'vuex'
Vue.use(Vuex)
let cart = window.localStorage.getItem('cart');
let confirm = window.localStorage.getItem('confirm');
let cartCount = window.localStorage.getItem('cartCount');
let userInfo = window.localStorage.getItem('userInfo');
let countries = window.localStorage.getItem('countries');
let authentication = localStorage.customer_id;
let Authorization = localStorage.Authorization;
let order = localStorage.order;
let billingaddess = localStorage.billingaddess;
let deliveryaddress = localStorage.deliveryaddress;
let subtotalPrice = window.localStorage.getItem('subtotalPrice');
let vat = window.localStorage.getItem('vat');
let shippingCharge = window.localStorage.getItem('shippingCharge');
let total = window.localStorage.getItem('total');
let subscriptionItem = window.localStorage.getItem('subscriptionItem'); // lms cart
let subscriptionCartCount = window.localStorage.getItem('subscriptionCartCount'); // lms cart count

export const store = new Vuex.Store({
  state: {
    cart: cart ? JSON.parse(cart) : [],
    confirm: confirm ? JSON.parse(confirm) : [],
    cartCount: cartCount ? parseInt(cartCount) : 0,
    auth: authentication ? authentication : 0,
    Authorization: Authorization ? Authorization : 0,
    order: order ? order : 0,
    billingaddess: billingaddess ? billingaddess : 0,
    deliveryaddress: deliveryaddress ? deliveryaddress : 0,
    userInfo: userInfo ? JSON.parse(userInfo) : [],
    countries: countries ? JSON.parse(countries) : [],

    subtotalPrice: subtotalPrice ? subtotalPrice : 0,
    vat: vat ? vat : 0,
    shippingCharge: shippingCharge ? shippingCharge : 0,
    total: total ? total : 0,
    subscriptionItem: subscriptionItem ? subscriptionItem : [], // lms cart
    subscriptionCartCount: subscriptionCartCount ? parseInt(subscriptionCartCount) : 0,

    // list of dynamically API generated routes
    dynamicRoutes: {},
    contactInfo: {},threeDRequestData:{},
    deviceDataCollectionData:{},
  },
  // getters are Vuex's equivalent to computed properties in Vue.
  // functions here will always contain state as a parameter
  getters: {

    total: state => {
      if (state.cart.length > 0) {
        return state.cart.map(item => item.item.id).reduce((total, amount) => total + amount);
      } else {
        return 0;
      }
    },
  },
  // mutations are essentially functions that update state in some way.
  // You can think of these as kind of being Vuex's equivalent to Vue's methods.
  mutations: {

    addToCart(state, item) {
      let found = state.cart.find(product => product.item.id === item.currentproductid);

      if (found) {
        found.quantity = item.quantity;
        found.is_course_for_me = typeof item.is_course_for_me === undefined ? '0' : item.is_course_for_me;
        found.totalPrice = found.quantity * found.retail_price;
      } else {
        state.cart.push(item);

        Vue.set(item, 'quantity', item.quantity);
        Vue.set(item, 'is_course_for_me', typeof item.is_course_for_me === undefined ? '0' : item.is_course_for_me);
        Vue.set(item, 'totalPrice', item.retail_price);
      }

      state.cartCount = state.cart.length;
      window.localStorage.setItem('cart', JSON.stringify(state.cart));
      window.localStorage.setItem('cartCount', state.cartCount);
    },

    confirm(state, item) {
      let found = state.confirm.find(product => product.item.id === item.currentproductid);

      if (found) {
        found.quantity = item.quantity;
        found.is_course_for_me = typeof item.is_course_for_me === undefined ? '0' : item.is_course_for_me;
        found.totalPrice = found.quantity * found.retail_price;
      } else {
        state.confirm.push(item);

        Vue.set(item, 'quantity', item.quantity);
        Vue.set(item, 'is_course_for_me', typeof item.is_course_for_me === undefined ? '0' : item.is_course_for_me);
        Vue.set(item, 'totalPrice', item.retail_price);
      }

      window.localStorage.setItem('confirm', JSON.stringify(state.confirm));
    },

    removeFromCart(state, item) {
      let index = state.cart.indexOf(item);

      if (index > -1) {
        let product = state.cart[index];
        if (state.cartCount != 0) {
          state.cartCount--;
        }

        state.cart.splice(index, 1);
      }

      window.localStorage.setItem('cart', JSON.stringify(state.cart));
      window.localStorage.setItem('cartCount', state.cartCount);
    },

    clearCart(state){
      window.localStorage.setItem('cart', "");
      window.localStorage.setItem('cartCount', 0);

      state.cart      = [];
      state.cartCount = 0;
    },

    clearConfirm(state) {
      window.localStorage.removeItem('confirm');
      state.confirm = [];
    },

    removeFromConfirm(state, item) {
      let index = state.confirm.indexOf(item);

      if (index > -1) {
        let product = state.confirm[index];
        if (state.cartCount != 0) {
          state.cartCount--;
        }

        state.confirm.splice(index, 1);
      }

      window.localStorage.setItem('confirm', JSON.stringify(state.confirm));
    },

    billingaddess(state, status) {
      state.billingaddess = status;
    },

    deliveryaddress(state, status) {
      state.deliveryaddress = status;
    },

    auth(state, status) {
      state.auth = status;
    },

    email(state, email) {
      state.email = email;
    },

    order(state, status) {
      state.order = status;
    },

    netAmount(state, item) {
      state.subtotalPrice = item.subtotalPrice;
      state.vat = item.vat;
      state.shippingCharge = item.shippingCharge;
      state.total = item.total;
      window.localStorage.setItem('subtotalPrice', state.subtotalPrice);
      window.localStorage.setItem('vat', state.vat);
      window.localStorage.setItem('shippingCharge', state.shippingCharge);
      window.localStorage.setItem('total', state.total);
    },

    dynamicRoutes(state, routes) {
      state.dynamicRoutes = routes;
    },

    addUserInfo(state, user) {
      state.userInfo = user;
      window.localStorage.setItem('userInfo', JSON.stringify(state.userInfo));
    },
    
    addCountries(state, countries) {
      state.countries = countries;
      window.localStorage.setItem('countries', JSON.stringify(state.countries));
    },

    updateUserInfo(state, user) {
      user.forEach(function (index, data) {
        state.userInfo[index] = data;
      });

      window.localStorage.setItem('userInfo', JSON.stringify(state.userInfo));
    },
    storeContactInfo(state, contactInfo){
      state.contactInfo = contactInfo;
    },
    store3DSecureRequest(state,data){
      state.threeDRequestData = data;
    },
    storeDeviceDataCollectionRequest(state,data){
      state.deviceDataCollectionData = data;
    },
    clear3DSiframeData(state){
      state.threeDRequestData = {};
      state.deviceDataCollectionData = {};
    },
    subscribtionCart(state, item) {
      state.subscriptionItem = JSON.stringify(item.item)
      state.subscriptionCartCount = 1;
      window.localStorage.setItem('subscriptionCartCount', state.subscriptionCartCount);
    },
    clear3DSiframeLicenseData(state){
      state.deviceDataCollectionData = {};
    },
    subscribtionClearCart(state){
      window.localStorage.setItem('subscriptionItem', "");
      window.localStorage.setItem('subscriptionCartCount', 0);

      state.subscriptionItem      = [];
      state.subscriptionCartCount = 0;
    },
  },


  // actions are effectively the functions that get called by your components in order to trigger a mutation.
  actions: {
    // add(context) {
    //     context.commit('add')
    // }
  }

})
